/**
* this displays the list of fund documents
*
* Created by Paul on 20/05/19
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import cx from 'classnames'
import { connect } from 'react-redux'

import { FaCloudDownloadAlt } from 'react-icons/fa'
import { FaTrashAlt } from 'react-icons/fa'

// action import
import { ActionCreator } from '../../actions/'
import AppLink from '../../components/AppLink'
import AppButton from '../../components/AppButton/'

// Configurations
import constants from '../../constants'

// material-ui import
import { withStyles, makeStyles } from '@material-ui/styles'
import Typography from '@material-ui/core/Typography'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import IconButton from '@material-ui/core/IconButton'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import LastPageIcon from '@material-ui/icons/LastPage'

// style import
import './style.scss'

const styles = theme => ({
    root: {
        flexShrink: 0,
        color: 'rgba(0, 0, 0, 0.54)',
        marginLeft: 25,
    },
})

class FundDocuments extends Component {

    constructor(props) {
        super(props)
        this.state = { count: 0, page: 0, rowsPerPage: 5 }
    }

    componentDidMount() {
        
        const { getDocumentsData, fund } = this.props
        getDocumentsData(fund.fund_code)
    }

    handleDeleteDocument(member_id, document_id) {
        
        const { deleteDocument } = this.props
        
        let payload = {
            member_id: member_id,
            document_id: document_id
        }
        deleteDocument(payload)
    }


    handleFirstPageButtonClick(event) {
        //onChangePage(event, 0);
        this.setState({
            page: 0
        })
    }

    handleBackButtonClick(event) {
        //onChangePage(event, page - 1);
        this.setState({
            page: this.state.page - 1
        })
    }

    handleNextButtonClick(event) {
        //onChangePage(event, page + 1);
        this.setState({
            page: this.state.page + 1
        })
    }

    handleLastPageButtonClick(event) {
        //onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));

        this.setState({
            page: Math.max(0, Math.ceil(this.state.count / this.state.rowsPerPage) - 1)
        })
    }

    render() {

        return (
            <p>meh</p>
        )
    }

    render_old() {

        const { documentListData, isLoading } = this.props

        const documents = documentListData.map((doc, index) =>
            <tr key={index}>
                <td>{ doc.file_name }</td>
                <td>{ doc.created }</td>
                <td>{ doc.category }</td>
                <td><div className="action-icons"><a target="_blank" href={`${process.env.REACT_APP_WEBSITE_URL}` + doc.download_url}><FaCloudDownloadAlt className="action-icons--icon" /></a> <FaTrashAlt onClick={() => this.handleDeleteDocument(doc.user_id, doc.id)} className="action-icons--icon" /></div></td>
            </tr>
        )

        return (

                <div className="main-container main-container__fund">
                
                    { isLoading ? (
                        <div className="info-default__item">Loading ...</div>
                    ):(
                        
                        documentListData.length > 0 ? (
                            <div className="fund-documents">
                                <div className="info-block__sub-heading">
                                    Fund Documents
                                </div>
                                <table>
                                    <thead>
                                        <tr className="header-row">
                                            <th>File name</th>
                                            <th>Created</th>
                                            <th>Category</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-body">
                                        { documents }
                                    </tbody>
                                </table>
                            </div>
                        ):(
                            <div className="info-default__item">No documents exist for this fund</div>
                        )
                    )}

                    {/* add fund button */}
                    <div className="main-container__funds__add-fund-button">
                        <AppLink
                            isExternal={true}
                            route={'test'}
                        >
                        <AppButton
                            buttonText="Upload"
                            size="small"
                            color="blue"/>
                        </AppLink>
                    </div>

                </div>        
        )
    }
}

// define the prop types
FundDocuments.propTypes = {
    classes: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    documentListData: PropTypes.array
}

const mapStateToPros = (state) => {
    return {
        isLoading: state.documentsState.isLoading,
        documentListData: state.documentsState.documentListData
    }
}

const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        getDocumentsData: action.getDocumentsData,
        deleteDocument: action.deleteDocument
    }
}

export default connect(mapStateToPros,mapDispatchToProps)(withStyles(styles)(FundDocuments))


// WEBPACK FOOTER //
// ./src/components/FundDocuments/index.js